<template>
  <article class="media reply">
    <div class="media-content">
      <div class="content pt-2">
        <section class="user-name-container flex-wrap">
          <div class="user-container">
            <img :src="avatar_url" class="image is-32x32 mr-1 rounded">
            <strong>{{ name }}</strong>
          </div>

          <UpdatingTime :time="created_on" class="text-muted"/>
        </section>
        <p v-if="!editing" class="white-space-pre">{{ body }}</p>
        <textarea
          @keydown.esc="editing = false"
          @keydown.shift.enter="updateReply(cycleID, videoID, commentID, id)"
          v-if="editing"
          v-textautosize
          v-select
          class="textarea reply-textarea"
          placeholder="Add a comment..."
          ref="reply"
          :value="body"/>
        <div class="button-container mt-2">
            <button
              v-if="editing"
              type='button'
              class='button is-small is-info'
              :class="updating && 'is-loading'"
              @click="updateReply(cycleID, videoID, commentID, id)">
                Save
            </button>
            <span>
              <button
                v-if="editing"
                type='button'
                class='button is-small is-danger'
                :class="deleting && 'is-loading'"
                @click="deleteReply(cycleID, videoID, commentID, id)">
                Delete
              </button>
              <input
                v-if="editing"
                type='button'
                class='button is-small'
                @click="editing = !editing"
                value='Cancel' />
            </span>

            <a
              v-if="!editing && editable"
              @click="editing = !editing"
              >Edit</a>
        </div>
      </div>
      </div>
  </article>
</template>

<script>
import UpdatingTime from './UpdatingTime.vue'

import store from '../store.js'

import { prettyDate } from '../filters.js'

import { textautosize, select } from '../directives.js'

export default {
  name: 'Reply',
  props: {
    commentID: {
      type: Number,
      required: true,
    },
    cycleID: {
      type: Number,
      required: false,
    },
    id: {
      type: Number,
      required: true,
    },
    videoID: {
      type: Number,
      required: true,
    },
    body: {
      type: String,
      required: true,
    },
    avatar_url: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    created_on: {
      type: String,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    UpdatingTime,
  },
  directives: {
    textautosize,
    select,
  },
  data () {
    return {
      editing: false,
      deleting: false,
      updating: false,
    }
  },
  methods: {
    updateReply (cycleID, videoID, commentID, replyID) {
      const content = this.$refs.reply.value
      this.updating = true
      store.dispatch('updateReply', {
        cycleID,
        videoID,
        commentID,
        replyID,
        content,
      })
      .then(() => {
        this.editing = false
        this.updating = false
      })
    },
    deleteReply (cycleID, videoID, commentID, replyID) {
      this.deleting = true
      store.dispatch('deleteReply', {
        cycleID,
        videoID,
        commentID,
        replyID,
      }).then(() => {
        this.deleting = false
      })
    },
  },
  filters: {
    prettyDate,
  },
}
</script>

<style lang="scss" scoped>

.user-container {
  display: flex;
  align-items: center;
}

.user-container > p {
  margin-right: 10px;
  margin-bottom: 0;
}

.reply-textarea {
  margin-top: 0.5rem;
}

.reply {
  margin-top: 0.75rem;
}

.user-name-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.white-space-pre {
  white-space: pre-wrap;
}

</style>



// WEBPACK FOOTER //
// Reply.vue?8891f00c